<template>
  <draggable
    :group="{ name: 'module', put: false, pull: 'clone' }"
    :sort="false"
    :value="childModules"
    class="card-drag"
  >
    <div v-for="item in childModules" :key="item.code" class="card-item-box">
       <!--<div class="card-item">{{item.title}}</div>-->
      <!--通知公告和校内公文-->
      <div class="card-item" v-if="item.code == 'TINFO_NOTICE' || item.code == 'TINFO_POLICY_FILE' ">
        <p class="flex-box al-c mb10" style="color: #024A84;">
          <img :src="`${baseUrl}images/${item.code}.png`" alt="">
          <span class="ml10 font-14">{{item.title}}</span>
        </p>
        <div v-if="item.code == 'TINFO_NOTICE'">
          <template v-for="(e, i) in noticeList">
            <p class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item" :key="i" v-if="i<5">
              <span class="flex-1 mr10 ellipsis">{{e.name}}</span>
              <span class="grey">{{e.createTime}}</span>
            </p>
          </template>
          <div v-if="noticeList.length == '0'" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
          <div class="selected" v-if="ifSelected(item)">已选</div>
        </div>
        <div v-if="item.code == 'TINFO_POLICY_FILE'">
          <template v-for="(e, i) in policyFileList">
            <p class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item" :key="i" v-if="i<5">
              <span class="flex-1 mr10 ellipsis">{{e.name}}</span>
              <span class="grey">{{e.createTime}}</span>
            </p>
          </template>
          <div v-if="policyFileList.length == '0'" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
          <div class="selected" v-if="ifSelected(item)">已选</div>
        </div>
      </div>
      <!--校历-->
      <div class="card-item" v-if="item.code == 'TINFO_CALENDAR'">
        <!--<img :src="`${baseUrl}images/${item.code}.png`" alt="">-->
        <!--<span class="ml10 font-14">校历</span>-->
        <template>
          <schoolDate :itemData="item"></schoolDate>
        </template>
        <div v-if="!item.data" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
        <div class="selected" v-if="ifSelected(item)">已选</div>
      </div>
      <!--便签-->
      <div class="card-item" v-if="item.code == 'TINFO_LABLE'">
          <template>
            <note :itemData="item"></note>
          </template>
          <div v-if="!item.data" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
          <div class="selected" v-if="ifSelected(item)">已选</div>
      </div>
      <!--日程-->
      <div class="card-item" v-if="item.code == 'TINFO_SCHEDULE'">
        <template>
          <schedule :itemData="item"></schedule>
        </template>
        <div v-if="!item.data" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
        <div class="selected" v-if="ifSelected(item)">已选</div>
      </div>
      <!--事务-->
      <div class="card-item" v-if="item.code == 'TINFO_AFFAIR'">
        <template>
          <affair :itemData="item"></affair>
        </template>
        <div v-if="!item.data" class="po-r mt10 mb10 font-12 ellipsis cu-p flex-box msg-item">暂无数据</div>
        <div class="selected" v-if="ifSelected(item)">已选</div>
      </div>
    </div>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
import schoolDate from './SchoolDate.vue'
import  note from './Note.vue'
import  schedule from './Schedule.vue'
import  affair from './affair.vue'
import {getCardList} from '@/api/managementCenter/specialManage'
export default {
  name: "cardC",
  components: { draggable, schoolDate, note,schedule, affair},
  props: ['childModules','homeModules'],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
        noticeList: [],
        policyFileList: [],
    };
  },
  created() {
  },
  computed: {},
    mounted(){
        this.getCardData('0');
        this.getCardData('1');
    },
  methods: {
      getCardData(type){
          let params = {
              type: type || ''
          }
          getCardList(params).then(res =>{
              if(type == '0'){
                  this.noticeList = res.data.data.records
              }
              if(type == '1'){
                  this.policyFileList = res.data.data.records
              }

          })
      },
    addClick(data){
      this.$emit('addClick', data)
    },
    ifSelected(val){
      let cardModule = this.homeModules.find(item => item.cardType === 'CARD')
      if(cardModule){
        if(cardModule.cardModules){
          return cardModule.cardModules.some(item => item.code === val.code)
        }
        return false
      }
      return false
    }
  },
  watch: {},
  filters: {},
};
</script>

<style lang="less" >
.card-drag {
  height: 480px;
  overflow: scroll;
  .card-item-box {
    display: flex;
    justify-content: center;
    margin-bottom: 12px;
    .card-item {
      width: 380px;
      height: 220px;
      // text-align: center;
      // line-height: 160px;
      background-color: #eef4f9;
      border-radius: 4px;
      position: relative;
      padding: 10px;
      overflow: hidden;
      cursor: move;
      .msg-item {
        line-height: 14px;
        cursor: inherit;
      }
    }
  }
}
.titleClass{
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px #e9e9e9 solid;
  padding: 5px 0;
}
</style>